/**
 * 時間文字列をhh:mm形式にフォーマットする
 * @param timeString - "HH:MM:SS" または "HH:MM" 形式の時間文字列
 * @returns "HH:MM" 形式の時間文字列、または空文字列/null/undefinedの場合は元の値を返す
 */
export const formatTimeToHHMM = (timeString?: string | null): string => {
  if (!timeString) return '';

  // すでにHH:MM形式の場合はそのまま返す
  if (timeString.length === 5 && timeString.match(/^\d{2}:\d{2}$/)) {
    return timeString;
  }

  // HH:MM:SS形式の場合、秒を削除
  if (timeString.length === 8 && timeString.match(/^\d{2}:\d{2}:\d{2}$/)) {
    return timeString.substring(0, 5);
  }

  // その他の形式の場合はそのまま返す
  return timeString;
};
